<div class="sms-tracking-container">
  <!-- Date Range Filter Section -->
  <div class="filter-section">
    <div class="box">
      <div class="date-range-header">
        <h5>Date Range Filter</h5>
      </div>
      <form [formGroup]="form">
        <div class="date-fields-row">
          <!-- Date From -->
          <div class="date-field">
            <mat-form-field appearance="outline">
              <mat-label>Range From</mat-label>
              <input matInput [matDatepicker]="dateFromPicker" formControlName="dateFrom" readonly />
              <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
              <mat-datepicker #dateFromPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Date To -->
          <div class="date-field">
            <mat-form-field appearance="outline">
              <mat-label>Range To</mat-label>
              <input matInput [matDatepicker]="dateToPicker" formControlName="dateTo" readonly />
              <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
              <mat-datepicker #dateToPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- SMS Type -->
          <div class="date-field">
            <mat-form-field appearance="outline">
              <mat-label>SMS Type</mat-label>
              <mat-select formControlName="smsType">
                <mat-option value="">All</mat-option>
                <mat-option value="OTP">OTP</mat-option>
                <mat-option value="Regular">Regular</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>

        <!-- Quick Date Filters -->
        <div class="quick-filters">
          <button mat-stroked-button (click)="setDateRange(3)">Last 3 Days</button>
          <button mat-stroked-button (click)="setDateRange(7)">Last 1 Week</button>
          <button mat-stroked-button (click)="setDateRange(14)">Last 2 Weeks</button>
          <button mat-stroked-button (click)="setLastMonth()">Last 1 Month</button>
        </div>
      </form>
    </div>
  </div>

  <!-- Stats Cards Section -->
  <div class="stats-section">
    <div class="stat-card delayed" [class.active]="selectedStatusFilter === 'all'" (click)="onCardClick('all')">
      <div class="stat-icon">
        <mat-icon>notifications</mat-icon>
      </div>
      <div class="stat-label">Total</div>
      <div class="stat-value">{{ totalSmsCount | number }}</div>
    </div>

    <div class="stat-card appeal" [class.active]="selectedStatusFilter === 'success'" (click)="onCardClick('success')">
      <div class="stat-icon">
        <mat-icon>chat</mat-icon>
      </div>
      <div class="stat-label">Send</div>
      <div class="stat-value">{{ sendSmsCount | number }}</div>
    </div>

    <div class="stat-card dropped" [class.active]="selectedStatusFilter === 'failed'" (click)="onCardClick('failed')">
      <div class="stat-icon">
        <mat-icon>trending_down</mat-icon>
      </div>
      <div class="stat-label">Failed</div>
      <div class="stat-value">{{ failedSmsCount | number }}</div>
    </div>
  </div>

  <!-- Table Section -->
  <mat-card class="dashboard-card">
    <mat-card-header class="header-with-export" *ngIf="selectedStatusFilter">
      <div class="search-fields">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Recipient</mat-label>
          <input matInput [formControl]="$any(form).controls.sendTo" placeholder="Search by recipient" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Sender</mat-label>
          <input matInput [formControl]="$any(form).controls.sendby" placeholder="Search by sender" />
        </mat-form-field>
        <button mat-raised-button color="primary"  (click)="onSearch()">
          <mat-icon>search</mat-icon>
          Search
        </button>
      </div>
      <button mat-button [matMenuTriggerFor]="exportMenu" class="btn-secondary">
        <mat-icon>file_download</mat-icon>
        Export
      </button>
      <mat-menu #exportMenu="matMenu">
        <button mat-menu-item (click)="exportAllAsExcel()">
          <mat-icon>grid_on</mat-icon>
          All as Excel
        </button>
        <button mat-menu-item (click)="exportCurrentAsExcel()">
          <mat-icon>grid_on</mat-icon>
          Selected as Excel
        </button>
      </mat-menu>
    </mat-card-header>
    <mat-card-content class="dashboard-card-content">
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="sms-tracking-table">
          <!-- Checkbox Column -->
          <ng-container matColumnDef="check-box">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <!-- Sent Date/Time Column -->
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SENT DATE/TIME</th>
            <td mat-cell *matCellDef="let row">{{ (row.createdAt |date:'dd-MM-yyyy HH:mm:ss' ) || "N/A"}}</td>
          </ng-container>
          <ng-container matColumnDef="smsType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SMS TYPE</th>
            <td mat-cell *matCellDef="let row">{{ row.smsType || "N/A"}}</td>
          </ng-container>

          <!-- Send To Column -->
          <ng-container matColumnDef="sendTo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>RECIPIENT</th>
            <td mat-cell *matCellDef="let row">{{ row.sendTo || "N/A"}}</td>
          </ng-container>

          <!-- Send By Column -->
          <ng-container matColumnDef="sendby">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SENDER</th>
            <td mat-cell *matCellDef="let row">{{ row.sendby || "N/A"}}</td>
          </ng-container>

          <!-- Description Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>MESSAGE CONTENT</th>
            <td mat-cell *matCellDef="let row" class="description-cell"
                [matTooltip]="row.description || 'N/A'"
                matTooltipPosition="above">{{ row.description || "N/A"}}</td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
             <td mat-cell *matCellDef="let row">
            <span class="status-badge"
          [class.success]="row.status === 200"
           [class.failed]="row.status !== 200">
         {{ row.status === 200 ? 'Sent' : 'Failed' }}
           </span>
         </td>
          </ng-container>

          <!-- Response Column -->
          <ng-container matColumnDef="response">
            <th mat-header-cell *matHeaderCellDef>SMS VENDOR RESPONSE</th>
            <td mat-cell *matCellDef="let row" class="response-cell"
                [matTooltip]="row.response || 'N/A'"
                matTooltipPosition="above">{{ row.response || "N/A"}}</td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>ACTION</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button class="view-btn" (click)="openSmsDetails(row)" matTooltip="View Details">
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- No Data Row -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="9">{{ 'NO_DATA_FOUND' | translate }}</td>
          </tr>
        </table>
      </div>
    </mat-card-content>

    <mat-paginator
      class="custom-paginator"
      [length]="totalRecords"
      [pageIndex]="pageNo"
      [pageSize]="pageSize"
      [pageSizeOptions]="config.pageSizeOptionsList"
      (page)="onPageChange($event)"
      showFirstLastButtons>
    </mat-paginator>
  </mat-card>
</div>
